import React, { useRef, useState } from 'react';
import { Drawer } from 'antd';
import StationChart from './StationChart';
import CustomIcon from '../CustomIcon';
import HistoricalChart from './HistoricalChart';
import { IoClose } from 'react-icons/io5';

const StationChartDrawer = ({ 
  data, 
  setCompareData,
  setData, 
  forecastData, 
  selectedStation, 
  selectedScenario, 
  setOpenDrawer, 
  setSelectedStation, 
  setOpen, 
  setSteps, 
  scenarioBase,
  setShowCompareStation,
  compareData,
  showCompareStation,
  compareForecastData,
  loadingMainChart,
  loadingCompareChart,
  selectedCompareStation,
  setSelectedCompareStation,
}) => {
  const ref0 = useRef(null);
  const heightDrawer = forecastData ? 600 : 350;

  const steps = [
    {
      title: 'Informations station',
      description: "Depuis cette vue vous visualisez les informations liées à la station choisie. Vous pouvez cliquer sur une station de la carte pour afficher ses données. cliquez sur la croix pour fermer ce panneau.",
      target: () => ref0.current,
    }
  ]
  const renderTile = <p className="drawer-title info-bulle" ref={ref0}>
    Station : {selectedStation?.name} ({selectedStation?.code})
     { forecastData &&
      <span>
        <CustomIcon setOpen={setOpen} setSteps={setSteps} steps={steps} />
      </span>
     }
    </p>;

  const drawerTitle = renderTile;
  const openDrawer = selectedStation && selectedScenario;

  const onClose = () => {
    setOpenDrawer(false);
    setData([]);
    setSelectedStation(null);
    setShowCompareStation(null);
    setSelectedCompareStation(null);
  };
  const renderCloseDrawer = <IoClose className="close-drawer" size={26} color="#333" onClick={() => onClose()} />;

  const renderChart = () => {
    if (forecastData) {
      return (
        <StationChart 
          scenarioBase={scenarioBase}  
          data={data} 
          forecastData={forecastData}
          compareForecastData={compareForecastData}
          setOpen={setOpen} 
          setSteps={setSteps} 
          selectedStation={selectedStation}
          setShowCompareStation={setShowCompareStation}
          compareData={compareData}
          showCompareStation={showCompareStation}
          loadingCompareChart={loadingCompareChart}
          loadingMainChart={loadingMainChart}
          setCompareData={setCompareData}
          selectedCompareStation={selectedCompareStation}
          setSelectedCompareStation={setSelectedCompareStation}
        />
      )
    } 
    return <HistoricalChart data={data} selectedStation={selectedStation} />
  }

  return (
    <>
      <Drawer
          destroyOnClose
          title={forecastData ? drawerTitle : null}
          width={320}
          height={heightDrawer}
          placement='bottom'
          closable={false}
          onClose={onClose}
          open={openDrawer}
          mask={false}
          maskClosable={false}
        >
        {
          renderChart()
        }
        {renderCloseDrawer}
        </Drawer>
    </>
  );
};
export default StationChartDrawer;